import { render } from "./UiPropParamsList.vue?vue&type=template&id=271a67a5"
import script from "./UiPropParamsList.vue?vue&type=script&lang=js"
export * from "./UiPropParamsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__